import dynamic from 'next/dynamic';

export enum RichTextEntries {
  Button = 'Button',
  LeadGenBanner = 'LeadGenBanner',
  People = 'People',
}

export enum ContentTypeName {
  HighlightSection = 'HighlightSection',
  ThumbnailSection = 'ThumbnailSection',
  ThumbnailCarousel = 'ThumbnailCarousel',
  LeadGenBanner = 'LeadGenBanner',
  SeoSection = 'SeoSection',
  Wrapper = 'Wrapper',
  PageOverviewBanner = 'PageOverviewBanner',
  CarrierSection = 'CarrierSection',
  Carrier = 'Carrier',
  Article = 'Article',
  Tag = 'Tag',
  Market = 'Market',
  Tradelane = 'Tradelane',
}

export enum ContentTypeIds {
  Asset = 'Asset',
  article = 'article',
  button = 'button',
  carrier = 'carrier',
  chart = 'chart',
  company = 'company',
  companyDirectory = 'companyDirectory',
  contentItem = 'contentItem',
  footer = 'footer',
  header = 'header',
  highlightSection = 'highlightSection',
  leadGenBanner = 'leadGenBanner',
  market = 'market',
  notificationTranslation = 'notificationTranslation',
  onboardingPopup = 'onboardingPopup',
  people = 'people',
  pmtPage = 'pmtPage',
  retailer = 'retailer',
  seo = 'seo',
  seoSection = 'seoSection',
  tag = 'tag',
  thumbnailCarousel = 'thumbnailCarousel',
  thumbnailSection = 'thumbnailSection',
  tradelane = 'tradelane',
  mainTranslation = 'mainTranslation',
  trackingTranslation = 'trackingTranslation',
  landingPage = 'landingPage',
  wrapper = 'wrapper',
  pageOverviewBanner = 'pageOverviewBanner',
  pmtOnboardingPopup = 'pmtOnboardingPopup',
}

export const entryPages: ContentTypeIds[] = [
  ContentTypeIds.article,
  ContentTypeIds.carrier,
  ContentTypeIds.companyDirectory,
  ContentTypeIds.landingPage,
  ContentTypeIds.pmtPage,
  ContentTypeIds.tag,
  ContentTypeIds.market,
];

export const entryMaster: ContentTypeIds[] = [ContentTypeIds.retailer, ContentTypeIds.tradelane];

export const ContentTypeRichText: {
  [key: string]: string;
} = {
  [ContentTypeIds.article]: 'content',
  [ContentTypeIds.landingPage]: 'content',
  [ContentTypeIds.wrapper]: 'content',
};

export enum DataPickerContentType {
  carrier = 'carrier',
  article = 'article',
  market = 'market',
  retailer = 'retailer',
}

export const ContentTypeMapping: {
  [key in ContentTypeName]?: React.ComponentType<any>;
} = {
  [ContentTypeName.HighlightSection]: dynamic(async () => import('../components/HighlightSection')),
  [ContentTypeName.ThumbnailSection]: dynamic(async () => import('../components/ThumbnailSection')),
  [ContentTypeName.ThumbnailCarousel]: dynamic(async () => import('../components/ThumbnailCarousel')),
  [ContentTypeName.LeadGenBanner]: dynamic(async () => import('../components/LeadGenBanner')),
  [ContentTypeName.SeoSection]: dynamic(async () => import('../components/SEOSection')),
  [ContentTypeName.Wrapper]: dynamic(async () => import('../components/Wrapper')),
  [ContentTypeName.PageOverviewBanner]: dynamic(async () => import('../components/PageOverviewBanner')),
  [ContentTypeName.CarrierSection]: dynamic(async () => import('../components/DataSection')),
};

export enum CategoryContentTypeIds {
  carrier = 'carrier',
}

export const CategoryTypes: {
  [key in CategoryContentTypeIds]: {
    plural: string;
  };
} = {
  [CategoryContentTypeIds.carrier]: {
    plural: 'carriers',
  },
};
